<template>
  <v-content class="confirm-email page">
    <v-progress-linear
      v-if="loading"
      :color="themes.candidate.light.loading"
      :height="5"
      indeterminate
    />
    <v-container v-else>
      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card raised class="mt-3">
            <v-toolbar card :color="themes.candidate.light.dialogTitle">
              <v-toolbar-title class="headline">Email Verification</v-toolbar-title>
            </v-toolbar>

            <div v-if="loggedIn">
              <v-card-text>
                <p>It looks like your email verification is invalid or has expired.</p>
                <p v-if="sent">
                  <v-icon left :color="themes.candidate.light.success">mdi-email-check</v-icon>
                  A new verification has been emailed to you.
                </p>
                <p v-else>Click on the below button to resend the email verification.</p>
              </v-card-text>
              <v-card-actions class="text-xs-right">
                <v-spacer />
                <v-btn
                  v-if="sent"
                  :color="themes.candidate.light.primaryActionButton"
                  to="/dashboard"
                >
                  Take me to my Dashboard
                </v-btn>
                <v-btn
                  v-else
                  :color="themes.candidate.light.primaryActionButton"
                  :loading="sending"
                  @click="confirm"
                >
                  Resend Verification
                </v-btn>
              </v-card-actions>
            </div>

            <div v-show="!loggedIn">
              <v-card-text>
                <p>You need to be logged in to verify your email address.</p>
                <p>Please login and try again.</p>

                <Login @done="reload" />
              </v-card-text>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
// Components
import Login from '@/components/Login.vue'

// Mixins
import { managedDocumentAttributes } from '@/mixins/managedDocumentAttributes.js'

import { mapGetters } from 'vuex'

export default {
  mixins: [managedDocumentAttributes],

  components: { Login },

  created() {
    this.documentAttributes.title = 'Verify Email - Leaply'

    if (this.token && this.role) {
      return Vue.$http.post(`${this.role}/confirm_email`, { token: this.token }).then(
        () => {
          this.$store.dispatch('snackbarSuccess', 'Email Verified')
          this.$store.dispatch('auth/refresh')
          this.confirmed = true
          this.loading = false
          if (this.role === 'candidates') this.$router.push('/candidate/profile')
        },
        errors => {
          this.$store.dispatch('snackbarError', 'Email Verification Failed')
          this.confirmed = false
          this.loading = false
        }
      )
    }
  },
  data() {
    return {
      token: this.$route.params.token,
      role: this.$route.params.role,
      confirmed: false,
      loading: true,
      sending: false,
      sent: false,
    }
  },
  computed: mapGetters({ loggedIn: 'auth/loggedIn', email: 'auth/email' }),
  methods: {
    confirm() {
      this.sending = true
      Vue.$http.get('candidate/candidate/send_email_confirmation').then(() => {
        this.sending = false
        this.sent = true
      })
    },

    reload() {
      window.location.reload()
    },
  },
}
</script>
